module.exports = __webpack_public_path__ + "img/sharp_bg.dfaad624.png";